import { Button, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { APP_ICONS } from "../../assets";
import CustomBar from "../../components/customBar";
import Loader from "../../components/loader";
import { getVendorDetails } from "../../services/Vendor";
import { constants } from "../../theme/Variables";
import NavigationDrawer from "./../../components/navigationDrawer/index";
import VendorCompletedOrders from "./CompletedOrders";
import VendorProfile from "./Profile";
import VendorStore from "./Store";
import WalletsAndPayment from "./WalletsAndPayment";

// Style Object for the Tab buttons
const useStyle = {
  activeTab: {
    bgcolor: "primary.main",
    color: "secondary.light",
    width: { xs: "100%", md: "auto" },
    px: 3,
    py: 1,
  },
  inActiveTab: {
    bgcolor: "secondary.light",
    color: "customColor.tundora",
    width: { xs: "100%", md: "auto" },
    px: 3,
    py: 1,
  },
};

// Tabs Data
const TABS = [
  {
    id: 0,
    label: "Personal Details",
    icons: {
      active: APP_ICONS.userIconWhite,
      inactive: APP_ICONS.userIconBlack,
    },
  },
  {
    id: 1,
    label: "Store Details",
    icons: {
      active: APP_ICONS.homeIconWhite,
      inactive: APP_ICONS.homeIconBlack,
    },
  },
  {
    id: 2,
    label: "Wallet & Payments",
    icons: {
      active: APP_ICONS.cashIconWhite,
      inactive: APP_ICONS.cashIconBlack,
    },
  },
  {
    id: 3,
    label: "Delivered Orders",
    icons: {
      active: APP_ICONS.cashIconWhite,
      inactive: APP_ICONS.cashIconBlack,
    },
  },
];

const VendorProfilePage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const { state } = useLocation();
  console.log(state, "statestatestatestate");

  const [vendorProfileData, setVendorProfileData] = useState(null);

  useEffect(() => {
    fetchVendorsDetails();
  }, []);

  const fetchVendorsDetails = async () => {
    try {
      setIsLoading(true);
      const response = await getVendorDetails(state?._id);
      setIsLoading(false);
      if (response?.status == 200 || response.status == 201) {
        let data = response?.data?.data || null;
        setVendorProfileData(data);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error, "errorerrorerrorerror");
    }
  };

  const handleOpenSnackBar = (type, message) => {
    constants.snackRef.isOpenSnack({
      snackType: type,
      snackMessage: message,
    });
  };

  const renderTabButton = (tab) => {
    const { id, label, icons } = tab;
    const isActive = activeTab === id;
    const icon = isActive ? icons.active : icons.inactive;

    return (
      <Button
        key={id}
        variant="tab_button"
        startIcon={<img src={icon} width={25} alt={`${label} Icon`} />}
        sx={isActive ? useStyle.activeTab : useStyle.inActiveTab}
        onClick={() => setActiveTab(id)}
      >
        {label}
      </Button>
    );
  };

  const filteredTabs =
    state?.role == "user"
      ? TABS.filter((tab) => tab.label !== "Store Details")
      : TABS;

  return (
    <NavigationDrawer>
      <Loader isloading={isLoading} />
      <CustomBar
        title={
          state?.role == "user"
            ? "USER PROFILE (VIEW/EDIT)"
            : "VENDOR PROFILE (VIEW/EDIT)"
        }
      />
      <Stack
        p={2}
        bgcolor="customColor.moonRaker"
        direction={{ md: "row" }}
        alignItems="center"
        gap={1}
        flexWrap="wrap"
        mb={3}
        borderRadius={"12px"}
      >
        {filteredTabs.map(renderTabButton)}
      </Stack>

      {activeTab === 0 ? (
        <VendorProfile
          vendorDetails={vendorProfileData?.vendorDetails}
          state={state}
          setVendorProfileData={setVendorProfileData}
        />
      ) : activeTab === 1 ? (
        <VendorStore
          setIsLoading={setIsLoading}
          state={state}
          storeData={vendorProfileData?.vendorStoreDetails}
          storeProducts={vendorProfileData?.vendorProducts}
          fetchVendorsDetails={fetchVendorsDetails}
        />
      ) : activeTab === 2 ? (
        <WalletsAndPayment
          state={state}
          walletsHistory={vendorProfileData?.walletHistory}
          data={vendorProfileData?.chartData}
        />
      ) : activeTab === 3 ? (
        <VendorCompletedOrders data={vendorProfileData} />
      ) : null}
    </NavigationDrawer>
  );
};

export default VendorProfilePage;
